import { render } from "./App.vue?vue&type=template&id=0c0d9bf7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0c0d9bf7&lang=css"

import exportComponent from "C:\\Users\\kmccullough\\Source\\Repos\\CPHub\\DoctorQueue.FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__